// extracted by mini-css-extract-plugin
export default {"modalOverlay":"vo-z","modalContent":"wo-z","header":"xo-z","close":"yo-z"};